import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { Permission } from "../Model/Permission";

export async function createPermission(data) {
	let response = await getAPIResponse("/v1/permission", data, "POST");
	if (response === null) {
		return null;
	}
	let permission = Permission.createFromResponseData(response);
	return permission;
}